import React from 'react';
import { Heading, Text, View, Button, IconInfoLine } from '@smarterservices/smarter-ui';
import Modal from '../Common/ModalContained';
import { useFullScreenMountNode } from '../../contexts/FullScreenContext';
import { getStore, useAppStore } from '../../stores/StoreContext';

/**
 * CheckinRequiredModal - Informs users they must start check-in before enabling microphone
 * 
 * This modal appears when a user attempts to enable their microphone before completing
 * the check-in process. It provides clear guidance on what they need to do next.
 */
function CheckinRequiredModal() {
    const AppStore = getStore('appStore');
    const mountNode = useFullScreenMountNode();
    const isOpen = useAppStore((state) => state.isCheckinRequiredModalOpen);

    const handleClose = () => {
        AppStore.closeCheckinRequiredModal();
    };

    const handleStartCheckin = () => {
        // Close the modal
        AppStore.closeCheckinRequiredModal();

        // Switch to the check-in tab in session details
        AppStore.setSessionDetailsTab('checkin');
    };

    return (
        <Modal
            open={isOpen}
            onDismiss={handleClose}
            label="Check-in Required"
            size="medium"
            mountNode={mountNode}
            shouldCloseOnDocumentClick={true}
            shouldCloseOnEscape={true}
        >
            <Modal.Header>
                <Heading level="h3" margin="0">
                    Begin Check-in Required
                </Heading>
                <Modal.CloseButton onClick={handleClose} label="Close" />
            </Modal.Header>

            <Modal.Body>
                <Text as="p" size="medium">
                    Before you can enable your microphone to communicate with the student, you must first start the check-in process.
                </Text>
                <View as="p" margin="small 0 0 0">
                    <Text as="p" size="medium">
                        Click the <strong>Start Check-in</strong> button below to begin the check-in process, or navigate to the Check-in tab in the session details panel.
                    </Text>
                </View>
            </Modal.Body>

            <Modal.Footer>
                <Button onClick={handleClose} margin="0 small 0 0">
                    Cancel
                </Button>
                <Button color="primary" onClick={handleStartCheckin}>
                    Start Check-in
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CheckinRequiredModal;
